import { jsx } from "panel";
import { DateInputEl } from "common/widgets/date-range-picker/calendar-input/date-input";
import { TooltipEl } from "common/components/tooltip";
import { CalendarEl } from "common/components/calendar";
import { DisplayType } from "common/components/tooltip/types";
export function template() {
  const { error, focused, from, isRangePicker, to } = this.state;
  const isFixedRange = this.helpers.isFixedRange();
  return /* @__PURE__ */ jsx("div", { sel: ".calendar-input" }, /* @__PURE__ */ jsx("div", { sel: ".date-inputs" }, /* @__PURE__ */ jsx(
    DateInputEl,
    {
      sel: ".from-date-input",
      class: { focused: focused === `from` },
      attrs: {
        error: !!error.from,
        value: from
      },
      on: {
        blur: this.helpers.blurredFrom,
        change: isFixedRange ? this.helpers.changedFixedRangeFrom : this.helpers.changedFrom,
        focus: this.helpers.focusedFrom,
        mouseenter: this.helpers.mouseenterFrom,
        mouseleave: this.helpers.mouseleaveFrom
      }
    }
  ), isRangePicker ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", { sel: ".preposition" }, "and"), /* @__PURE__ */ jsx(
    DateInputEl,
    {
      sel: ".to-date-input",
      class: { focused: focused === `to` },
      attrs: {
        error: !!error.to,
        value: to
      },
      on: {
        blur: this.helpers.blurredTo,
        change: isFixedRange ? this.helpers.changedFixedRangeTo : this.helpers.changedTo,
        focus: this.helpers.focusedTo,
        mouseenter: this.helpers.mouseenterTo,
        mouseleave: this.helpers.mouseleaveTo
      }
    }
  )) : null, error.from && this.helpers.isFromActive() ? /* @__PURE__ */ jsx(
    TooltipEl,
    {
      attrs: {
        type: DisplayType.Error,
        "always-show": true
      }
    },
    error.from
  ) : null, error.to && this.helpers.isToActive() ? /* @__PURE__ */ jsx(
    TooltipEl,
    {
      attrs: {
        type: DisplayType.Error,
        "always-show": true
      }
    },
    error.to
  ) : null), /* @__PURE__ */ jsx("div", { sel: ".calendars" }, /* @__PURE__ */ jsx(
    CalendarEl,
    {
      attrs: this.helpers.getCalendarAttrs(),
      on: {
        draw: this.helpers.propagateEvent,
        selectDate: isFixedRange ? this.helpers.selectedFixedRangeDate : this.helpers.selectedDate
      }
    }
  )));
}
